<template>
  <div class="sport-container">
    <v-card class="sport">
      <v-toolbar
        color="#E72480"
        dark
      >

        <v-toolbar-title style="font-weight: bold;font-size: 2rem">ورزشی</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="addDialog" >
          <v-icon>mdi-plus-thick  </v-icon>
        </v-btn>
      </v-toolbar>
      <div class="empty-array" v-if="originalSports.length===0">اطلاعاتی برای نشان دادن نداریم.</div>
      <div class="empty-array" v-if="originalSports.length===0">لطفا اطلاعات جدید را وارد کنید.</div>
      <div  class="child-offer">
        <v-card
          v-for="item in originalSports"
          width="344"
          style="margin: 20px auto"
        >
          <div class="image">
            <v-img
              lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU"
              :src="item.file ? baseUrl+item.file + '?'+ dates : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU'"
              height="250px"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <div class="icons">
              <v-btn :loading="deleteLoading" style="background-color: white" @click="deleteData(item.id)" icon>
                <v-icon color="red">mdi-delete  </v-icon>
              </v-btn>
              <v-btn @click="editData(item.plate,item.phoneNo,item.category,item.name, item.floor,item.id,item.file)" style="background-color: white" icon>
                <v-icon color="blue" >mdi-pencil  </v-icon>
              </v-btn>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-row  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">اسم:</div>
                  <div>{{item.name}}</div>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">پلاک:</div>
                  <div>{{item.plate}}</div>
                </v-row>
              </v-col>

            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-row  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">موقعیت:</div>
                  <div>{{item.floor}}</div>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">شماره تلفن:</div>
                  <div>{{item.phoneNo}}</div>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="8">
                <v-row  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">توضیح:</div>
                  <div>{{item.category}}</div>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </v-card>
    <v-dialog
      v-model="dialog"
      max-width="800"
      class="dialogs"
      v-on:click:outside="eybiyokh"
    >
      <v-card style="background-color: #d2d2d2;padding: 40px">

        <v-form validation v-model="valid">
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field
                v-model="nameSport"
                :rules="[nameSportRules]"
                label="اسم ورزش"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="9"
            >
              <v-text-field
                v-model="textSport"
                :rules="[textSportRules]"
                label="متن"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="telephoneNumber"
                :rules="[numberRules]"
                :counter="11"
                label="شماره تلفن"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="plateNumber"
                :rules="[plateRules]"
                label="پلاک واحد"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="select-floor"
            >
              <v-select
                style="flex-direction: column-reverse"
                :items="items"
                label="موقعیت ساختمان"
                solo
                v-model="floor"
                required
                :rules="[floorRules]"
              ></v-select>
            </v-col>
          </v-row>

          <v-col >
            <v-row style="direction:ltr;margin-bottom: 2rem">
              <v-file-input
                v-model="files"
                class="input"
                chips
                placeholder=""
                :rules="rules1"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                v-on:change="showImage($event)"
                v-on:click:clear="deleteImage"
                hide-details
                required
              ></v-file-input>
              <div style="display: flex;justify-content: center;align-items: center;" class="text">عکس مورد نظر خود را اپلود کنید</div>
            </v-row>
            <v-row style="width: 300px;">
              <v-img width="300" height="200" class="image-test"  :src="image" alt=""></v-img>
            </v-row>

          </v-col>


        </v-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black darken-1"
            text
            @click="eybiyokh()"
          >
            بیخیال
          </v-btn>
          <v-btn
            color="black darken-1"
            text
            :loading="sendLoading"
            @click="sendData"
            v-show="!isEdit"
            :disabled="!valid"
          >
            انجام شد
          </v-btn>
          <v-btn
            color="black darken-1"
            text
            @click="recordData"
            :loading="editLoading"
            v-show="isEdit"
            :disabled="!valid"
          >
            ویرایش کنید.
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {toBase64} from "../../../../plugins/toBase64";
  import {deleteSport, putSport, setSport} from "../../../../api/features/sports";
  import {mapActions, mapGetters} from "vuex";

  export default {
    name: "sport",
    data:()=>({
      dialog:false,
      isEdit:false,
      sendLoading:false,
      editLoading:false,
      id:0,
      text:'',
      files:[],
      fileCheck:true,
      textCheck:true,
      deleteLoading:false,
      check:true,
      valid:true,
      rules1: [],
      telephoneNumber: '',
      image:'',
      mortgageCost:0,
      nameSport:'',
      textSport:'',
      areaNumber:0,
      categories:'',
      plateNumber:"",
      dates:'',
      floor:'',
      baseUrl:'',
      items: [ 'طبقه دوم' ,'طبقه سوم_۱', 'طبقه سوم_۲','طبقه اول','طبقه دوم','طبقه منفی ۱','طبقه همکف'],
      numberRules: v  => {
        if( /^\d+$/.test(v)){
          if(v.length===11)
          {
            return true
          }
          return 'شماره موبایل باید ۱۱ رقم باشد.'
        }
        else{
          return 'متن وارد شده عدد نیست و اعداد رو به صورت انگلیسی وارد کنید.';
        }
      },

      nameSportRules:v =>{
        if(v && v.length <=30){
          return true
        }
        else{
          return 'متن وارد شده باید کمتر از ۳۰ کاراکتر باشد';
        }
      },
      textSportRules:v =>{
        if(v && v.length <=100){
          return true
        }
        else{
          return 'متن وارد شده باید کمتر از ۱۰۰ کاراکتر باشد';
        }
      },

      plateRules: v =>{
        if( /^\d+$/.test(v)){
          return true
        }
        else
        {
          return 'متن وارد شده عدد نیست و اعداد رو به صورت انگلیسی وارد کنید.';
        }
      },
      floorRules: v =>{
        if(v!=='' && v!==undefined)
        {
          return true
        }
        else
        {
          return 'طبقه واحد خود را وارد کنید.'
        }
      },


    }),
    methods:{
      showImage(e){
        if(e) {
          this.image = URL.createObjectURL(e)
        }
      },
      deleteImage()
      {
        this.image = ''
      },
      addDialog () {
        this.isEdit = false
        this.dialog = true
        this.areaNumber = 0
        this.image = ''
      },
      async sendData(){
        this.sendLoading = true
        let img = await toBase64(this.files)
          try{
            await setSport({
              name:this.nameSport,
              category:this.textSport,
              phoneNo:this.telephoneNumber,
              floor:this.floor,
              plate:this.plateNumber,
              file:img,
            }).then(()=>{

              this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
            }).catch(()=>{
              this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
            })
          }catch (e) {
            ////comment
          }
        await  this.getSportReq()
        this.dates = new Date()
        this.sendLoading =false
        this.dialog = false
        this.files=[]
        this.textSport=''
        this.nameSport = ''
        this.telephoneNumber = ''
        this.floor = ''
        this.plateNumber = ''
        this.image = ''
      },
      async recordData(){
        this.editLoading = true
        try {
          let img = await toBase64(this.files)
            await putSport({
              id: this.id,
              name:this.nameSport,
              category:this.textSport,
              phoneNo:this.telephoneNumber,
              floor:this.floor,
              plate:this.plateNumber,
              file:img,
            }, this.id).then(() => {

              this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
              // window.location.reload()
            }).catch(()=>{
              this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
            })

        }catch(e){
          ///comment
        }
        await this.getSportReq()
        this.dates = new Date()
        this.editLoading = false
        this.dialog = false
        this.area = 0
        this.telephoneNumber = ''
        this.mortgageCost = 0
        this.rentCost=0
        this.floor = ''
        this.plateNumber = ''
      },
      eybiyokh(){
        this.dialog = false
        this.files=[]
        this.textSport=''
        this.nameSport = ''
        this.telephoneNumber = ''
        this.floor = ''
        this.plateNumber = ''
        this.image = ''
      },
      async deleteData(id){
        try {
          let yes = confirm("مطمئنی میخوای پاک کنی!");
          if (yes) {
            this.deleteLoading = true
            await deleteSport(id).then(() => {
              this.dates = new Date()
              this.getSportReq()
            })
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات حذف شدن اعمال شد.', showSnackbar:true})
          }
        }catch (e) {
          this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
        }
         this.deleteLoading = false
      },
      editData(plate,phoneNo,category,nameSport,floor,id,imgPath){
        this.files = []
        this.nameSport = nameSport
        this.textSport = category
        this.telephoneNumber = phoneNo
        this.floor = floor
        this.plateNumber = plate
        this.id=id
        this.dialog = true
        this.isEdit = true
        this.image  = this.baseUrl+imgPath +'?'+this.dates;
      },
      ...mapActions({
        getSportReq:'sportStore/fetchSport',
        snackBarAction:'snackBar/snackBarAction'


      }),
    },
    computed: {
      ...mapGetters({
        originalSports: 'sportStore/get_sport',
      })
    },
    async mounted() {
      this.$emit('sport-toggle', false)
      this.baseUrl = process.env.VUE_APP_BASE_URL
      await this.getSportReq()
      this.$emit('sport-toggle', false)
    },
  }
</script>

<style scoped>
  .dialogs .row{
    align-items: center;
    justify-content: center;
  }
   .v-text-field{
    padding-top: 0;
    margin-top: 0;
  }
  .sport{
    width: 85%;
    margin: 0 auto;
  }
  .sport .row{
    justify-content: flex-start;
    align-items: center;
    margin: 0.3rem -7px;
  }
  .flex-direction{
    display: flex;
    flex-direction: row;
  }

  .child-offer{
    padding: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;
  }

  .input{
    direction: ltr;
  }

  .text{
    font-family: anjoman;
    font-size: 1.25rem;
  }

  .link-input{
    width: 40%;
  }
  .image{
    position:  relative;
  }
  .icons{
    position: absolute;
    top: 0;
    left: 0;
  }
  .empty-array{
    font-size: 2rem;
    margin-right: 3rem;
    font-weight: bold;
  }
  p{
    margin-right: 5px;
  }
</style>
